// extracted by mini-css-extract-plugin
export default {"paymentVariants":"ivvPw","skeleton-progress":"jYgiG"};